export default "__VITE_ASSET__8a19d0b1__"